module.exports = __webpack_public_path__ + "img/header.f87b5c26.png";